import styled from "styled-components";

export const TR = styled.tr`
    background: #fff;
    width: 100%;
`;
